module.exports = __webpack_public_path__ + "img/menu-01.1ff3bd93.svg";